import { FAQ as McFaq } from '@mc/faq'
import { useTranslation } from '@mc/i18n'
import { type SectionsOptions, useFaqData } from './hooks/useFaqData'

export const FAQ = ({
  eventType,
  eventLocation,
  pageSource = '',
  className = '',
  shouldShowLargeHeader = false,
  personaFAQ = false,
  sections,
  title,
  ...props
}: {
  eventType: string
  eventLocation: string
  pageSource?: string
  className?: string
  shouldShowLargeHeader?: boolean
  personaFAQ?: boolean
  sections?: SectionsOptions
  title?: string
  id?: string
}) => {
  const { t } = useTranslation('@mc/next')
  const { faqData } = useFaqData({ sections, personaFAQ })

  return (
    <section
      {...props}
      className={`mc-py-10 ${className}`}
      data-testid='faq-section'
      id='faq'
    >
      <McFaq
        mainTitle={title || t('faq.title.string')}
        data={faqData}
        trackingProps={{ name: eventType, location: eventLocation, pageSource }}
        appearance={{ shouldShowLargeHeader }}
        {...props}
      />
    </section>
  )
}
